import React from 'react'
import cn from 'classnames'

export type LoadingStateType = {
  rows?: number
}

const LoadingState = ({ rows = 2 }: LoadingStateType) => {
  return (
    <div className='loading-state'>
      {Array.from(Array(rows)).map((_, idx) => (
        <span
          key={idx}
          className={cn('loading-state__row', {
            'loading-state__row--large': idx % 2 === 0
          })}
        />
      ))}
    </div>
  )
}

export default LoadingState
